import money from '@/utils/money';

const state = {
  monthlyDeposit: 200,
  period: 5,
  interestRate: 0,
};

const getters = {
  compoundInterest: state => money.compoundInterest(0, state.monthlyDeposit, state.interestRate, state.period),
};

const mutations = {
  setMonthlyDeposit(state, monthlyDeposit) {
    state.monthlyDeposit = monthlyDeposit;
  },
  setPeriod(state, period) {
    state.period = period;
  },
  setInterestRate(state, interestRate) {
    state.interestRate = interestRate;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
